import React, {useEffect, useState} from 'react';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../../redux/selectors";

// providers
import {tabOptionProvider} from "../../../../providers/tabOptionProvider";
import {promotionTabOptionService} from "../../../../jwt/_services/relations/promotionTabOptionService";

// actions
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {ADD_STATE, REMOVE_STATE} from "../../../../redux/actions/generics/IndexedActions";

// components
import CustomSwitch from "../../../../components/customSwitch/CustomSwitch";
import {DragDropList} from "../../../../components/draggableList/DragDropList";
import {GenericContainer} from "../../../../components/containers/GenericContainer";
import {menuOptionsProvider} from "../../../../providers/menuOptionsProvider";


const TabOptionSection = (props) => {
    const path = props.path + '/tabOption';
    const [parent] = useState(props.parent || null);
    const componentState = useSelector(state => getStateByPath(state, path));
    const {listDomainObjects} = componentState?.data || [];
    const [tabOptions, setTabOptions] = useState([]);
    const [promotionTabOptions, setPromotionTabOptions] = useState([]);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        tabOptionProvider.getOptions().then((options) => {
            setTabOptions(options);
        });

        const dataRequest = {
            promotion: {id: parent?.id},
            tabOption: {id: null}
        };

        genericIndexedActions.search(path, promotionTabOptionService, 0, 100, dataRequest)
    }, []);

    useEffect(() => {
        if (tabOptions.length > 0 && listDomainObjects) {
            mapPromotionTabOptions();
        }
    }, [tabOptions, listDomainObjects]);

    const mapPromotionTabOptions = () => {
        const _promotionTabOptions = tabOptions.map(tabOption => {
            const promotionTabOption = listDomainObjects.find(domainObject => domainObject.tabOption.id === tabOption.id);
            return promotionTabOption || { tabOption, status: false };
        });

        setPromotionTabOptions(_promotionTabOptions);
    }

    const setStatus = (promotionTabOption) => {
        // Validar si promotionTabOption es null o undefined
        if (!promotionTabOption?.id) {
            // Crear
            const dataRequest = {
                tabOption: {id: promotionTabOption?.tabOption.id},
                promotion: {id: parent?.id},
                status: true,
                showOrder: 0
            };

            genericIndexedActions.save(path, promotionTabOptionService, dataRequest)
        } else {
            // Actualizar
            const dataRequest = {
                id: promotionTabOption.id,
                status: !promotionTabOption.status,
            };

            genericIndexedActions.update(path, promotionTabOptionService, promotionTabOption.id, dataRequest)
        }
    }


    const renderContent = (promotionTabOption, index) => {
        const lbl = promotionTabOption?.tabOption?.code || promotionTabOption?.tabOption?.value
        return (
            <CustomSwitch
                onClick={_ => setStatus(promotionTabOption)}
                label={ lbl?.toUpperCase().replace('_', ' ') }
                checked={ promotionTabOption?.status }
            />
        )
    }

    return (
        <GenericContainer
            titlle={'Tabs'}
            listItems={promotionTabOptions}
            renderContent={renderContent}
            orientationHV={'horizontal-container'}
            fullheight={false}
        />
    );
}

const mapStateToProps = _ => ({})

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
})

export default connect(mapStateToProps, mapActionsToProps)(TabOptionSection)
